import { SVGProps } from 'react';

export function Branch(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      width='24'
      height='24'
      fill='none'
    >
      <rect
        width='24'
        height='24'
        rx='2'
        fill='#E5FCD7'
      />
      <g clipPath='url(#clip0_1415_53455)'>
        <path
          d='M6 18H18'
          stroke='#29B52F'
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M6 8.66667V9.33333C6 9.86377 6.21071 10.3725 6.58579 10.7475C6.96086 11.1226 7.46957 11.3333 8 11.3333C8.53043 11.3333 9.03914 11.1226 9.41421 10.7475C9.78929 10.3725 10 9.86377 10 9.33333M6 8.66667H18M6 8.66667L7.33333 6H16.6667L18 8.66667M10 9.33333V8.66667M10 9.33333C10 9.86377 10.2107 10.3725 10.5858 10.7475C10.9609 11.1226 11.4696 11.3333 12 11.3333C12.5304 11.3333 13.0391 11.1226 13.4142 10.7475C13.7893 10.3725 14 9.86377 14 9.33333M14 9.33333V8.66667M14 9.33333C14 9.86377 14.2107 10.3725 14.5858 10.7475C14.9609 11.1226 15.4696 11.3333 16 11.3333C16.5304 11.3333 17.0391 11.1226 17.4142 10.7475C17.7893 10.3725 18 9.86377 18 9.33333V8.66667'
          stroke='#29B52F'
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M7.33325 18.0001V11.2334'
          stroke='#29B52F'
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M16.6667 18.0001V11.2334'
          stroke='#29B52F'
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M10 18V15.3333C10 14.9797 10.1405 14.6406 10.3905 14.3905C10.6406 14.1405 10.9797 14 11.3333 14H12.6667C13.0203 14 13.3594 14.1405 13.6095 14.3905C13.8595 14.6406 14 14.9797 14 15.3333V18'
          stroke='#29B52F'
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </g>
      <defs>
        <clipPath id='clip0_1415_53455'>
          <rect
            width='16'
            height='16'
            fill='white'
            transform='translate(4 4)'
          />
        </clipPath>
      </defs>
    </svg>
  );
}
